import type { ConfigurationFileModel } from '~/models'
import type { DynamicStyleOption } from '~/types/DynamicStyleOption'
export const useDynamicStyle = (): DynamicStyleOption => {
  const siteStore = useSiteStore()
  const cfg = siteStore.siteConfig as ConfigurationFileModel
  if (!cfg?.elements) return {} as DynamicStyleOption

  return {
    primaryColor: cfg.elements.primaryColor.value,
    contentAlignment: firstOrDefault(cfg.elements.contentAlignment.value)?.codename,
    heroBackgroundImageTaxonomy: firstOrDefault(cfg.elements.heroBackgroundImage.value)?.codename,
    customBackgroundImage: firstOrDefault(cfg.elements.customBackgroundImage.value)?.url,
    useBackgroundImage: multipleChoiceToBoolean(cfg?.elements?.useAHeroBackgroundImage)
  } as DynamicStyleOption
}
